// Main App Component
// This is the root component that contains all sections of our website

import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Network from './components/Network';
import InstinctiveLabs from './components/InstinctiveLabs';
import Projects from './components/Projects';
import Vision from './components/Vision';
import Newsletter from './components/Newsletter';
import CharacterSheet from './components/CharacterSheet';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SocialSideBar from './components/SocialSideBar';
import NavigationArrows from './components/NavigationArrows';
import ErrorTest from './components/ErrorTest';
import LogDownloader from './components/LogDownloader';
import ConsentBanner from './components/ConsentBanner';
import SkipToContent from './components/SkipToContent';

function App() {
  const showErrorTest = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('test-errors');

  return (
    <div className="App">
      <SkipToContent />
      <SocialSideBar />
      <NavigationArrows />

      <Header />
      <main id="main-content">
        <Hero />
        <Services />
        <InstinctiveLabs />
        <Network />
        <Projects />
        <Vision />
        <Newsletter />
        <CharacterSheet />
        <Contact />
      </main>
      <Footer />

      {showErrorTest && <ErrorTest />}
      <LogDownloader />
      <ConsentBanner />
    </div>
  );
}

export default App;
